const removeEmptyEntries = require('../../../../shared/utils/removeEmptyEntries');
const { ACTIVE_FILTER_SEPARATORS } = require('../constants');
const { staticUrl, staticSearchUrl } = require('../url');
const { CATEGORY_FILTER_SOURCE, FILTER, UNKNOWN_ALIAS, SELECTORS } = require('../../config/filters');

const additionalFilterParsers = {
    [FILTER.GIG_PRICE_RANGE.ID]: (id, val) => {

        if (!val) {
            return val;
        }

        const [min, max] = val.split(ACTIVE_FILTER_SEPARATORS.ARRAY_VALUE);
        return [Number(min), Number(max)];
    },
    [FILTER.LANGUAGES_PAIR.ID]: (id, val) => {
        const [fromValue, toValue] = val.split(ACTIVE_FILTER_SEPARATORS.PAIR_VALUE);
        return [fromValue, toValue];
    }
};

const arraySeparators = {
    [FILTER.LANGUAGES_PAIR.ID]: ACTIVE_FILTER_SEPARATORS.PAIR_VALUE
};

const utils = module.exports = {

    constructOptionObject({ alias = UNKNOWN_ALIAS, id, count }, filterValue) {
        return { alias, id, count, selected: !!(filterValue && filterValue.includes(id)) };
    },

    constructPairOption({ id, count, activeValue, existingOption, alias }) {
        const sumCount = existingOption ? existingOption.count + count : count;

        return utils.constructOptionObject({ id, count: sumCount, alias }, activeValue);
    },

    sortByCountDescending(a, b) {
        return b.count - a.count;
    },

    sortByOrderAscending(a, b) {
        return a.order - b.order;
    },

    sortByAliasAlphabetical(a, b) {
        return a.alias.localeCompare(b.alias);
    },

    optionValidation({ customFilters }, filterId, optionId){
        return !!(customFilters[filterId] && customFilters[filterId][optionId]);
    },

    filterValidation({ customFilters }, filterId, filtersToExclude, allowedNested){
        if (filtersToExclude.includes(filterId) && allowedNested.length !== 0){
            return false;
        }
        return !!customFilters[filterId];
    },

    constructResultObject({ config }, { ID, SELECTOR }, additionalParams = {}) {
        const { order, display_type } = (config[ID] || {});

        return {
            id: ID,
            order,
            display_type,
            selector: SELECTOR,
            ...additionalParams
        };
    },

    linkData(slugs, ref) {
        const queryParams = { source: CATEGORY_FILTER_SOURCE };
        let url = staticUrl(slugs);

        if (ref) {
            const params = `ref=${encodeURIComponent(ref)}`;
            url = `${url}?${params}`;
        }

        return removeEmptyEntries({
            url,
            params: queryParams
        });
    },

    constructSubCategoryAllObject(alias, slugs, count = 0) {
        return {
            alias,
            selected: false,
            count,
            ...utils.linkData(slugs)
        };
    },

    constructSearchSubCategoryOptionObject(alias, { categoryIds, allSubCategoriesCount }) {
        const { subCategoryId } = categoryIds;

        return {
            count: allSubCategoriesCount,
            alias,
            selected: subCategoryId === undefined,
            headAsLink: !!subCategoryId,
            params: {
                search_in: 'everywhere',
                sub_category: ''
            },
            url: staticSearchUrl()
        };
    },

    constructSubCategoryObject(count = 0, slugs, { categoryIds, subCategoryData }) {
        return {
            count,
            alias: subCategoryData.name,
            selected: !categoryIds.nestedSubCategoryId,
            ...utils.linkData(slugs)
        };
    },

    constructNestedSubCategoryOptionObject(nscId, count, src, slugs, { categoryIds, translationsService, ref }) {
        const { subCategoryId, nestedSubCategoryId } = categoryIds;

        return {
            id: nscId,
            count,
            src,
            alias: translationsService.categories.nscName(subCategoryId, nscId),
            selected: nestedSubCategoryId === nscId,
            ...utils.linkData({ ...slugs, nestedSubCategory: translationsService.categories.nscSlug(subCategoryId, nscId) }, ref)
        };
    },

    constructSubCategoryOptionObject(scId, count, { categoryIds, translationsService }) {
        const { subCategoryId } = categoryIds;

        return {
            count,
            alias: translationsService.categories.scName(scId),
            selected: subCategoryId === scId,
            params: {
                search_in: 'category',
                sub_category: scId
            },
            url: staticSearchUrl()
        };
    },

    activeFiltersToQueryString(activeFilters) {
        return Object.entries(activeFilters || {})
            .map(([ filterName, filterValue ]) =>
                `${filterName}${ACTIVE_FILTER_SEPARATORS.PARAM_VALUE}${_stringifyActiveFilterValue(filterName, filterValue)}`
            )
            .join(ACTIVE_FILTER_SEPARATORS.PARAMS);
    },

    parseActiveFilters(ref) {
        ref = ref || '';
        const filters = ref.split(ACTIVE_FILTER_SEPARATORS.PARAMS);
        return removeEmptyEntries(filters.reduce((activeFilters, filter) => {

            const [filterName, filterValue] = filter.split(ACTIVE_FILTER_SEPARATORS.PARAM_VALUE);
            const filterParsers = additionalFilterParsers[filterName] ? additionalFilterParsers[filterName] : _parseActiveFilterValue;
            activeFilters[filterName] = filterParsers(filterName, filterValue);

            return activeFilters;
        }, {}));
    },

    parseLanguagesPairFromFilters(filters) {
        const languagesPair = filters.find((filter) => filter.id === FILTER.LANGUAGES_PAIR.ID);

        return languagesPair ? languagesPair.options : [];
    },

    getFilterSelectedOption({ id, selector, options = [] }) {
        return options.reduce((acc, { id: value, alias, selected }) => {
            selected && acc.push({ id, value, alias, selector });
            return acc;
        }, []);
    }
};

const _stringifyActiveFilterValue = (name, value) => Array.isArray(value) ? value.join(arraySeparators[name] || ACTIVE_FILTER_SEPARATORS.ARRAY_VALUE) : value;
const _parseActiveFilterValue = (filterId, value) => SELECTORS.isMulti(filterId) ? multiSelectFilterValue(value) : _stripSingleValue(value);
const _stripSingleValue = (value) => Array.isArray(value) ? value[0] : value;
const multiSelectFilterValue = (value) => value ? value.split(ACTIVE_FILTER_SEPARATORS.ARRAY_VALUE) : [];
